export default __webpack_public_path__ + "static/media/Benton-Sans-Book-Italic.73543fe5.otf";